export const PageTitle = (pageTitle) => {

    return(document.title = pageTitle);

};